module.exports = __webpack_public_path__ + "static/img/chuFang.9989fd98.jpg";